import React, { useState } from "react";

function SkeletonTable({ columnCount, rowCount }) {
  const [columns] = useState([...Array(columnCount).keys()]);
  const [rows] = useState([...Array(rowCount).keys()]);

  return (
    <>
      {rows.map((item, indexRow) => {
        return (
          <tr key={indexRow} className="animate-pulse">
            {columns.map((item, indexColumn) => {
              return (
                <th key={indexColumn} scope="row">
                  <div></div>
                </th>
              );
            })}
          </tr>
        );
      })}
    </>
  );
}

export default SkeletonTable;
